try {
    window.$ = window.jQuery = require('jquery');
    window.Popper = require('popper.js/dist/umd/popper.js');
    require('bootstrap');
} catch (e) {}


require('./parts/header-menu.js');
require('./parts/home.js');


// WEBPACK FOOTER //
// ./resources/scripts/app.js